<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Complaint &amp; Feedback</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>
      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row mb-4">
          <div class="col-md-12">
            <div>
              <nav>
                <div class="nav nav-tabs ib-acq-navtab" id="nav-tab" role="tablist">
                  <a class="nav-item nav-link acq-nav-btn active" id="upload-information-tab" data-toggle="pill" href="#upload-information" role="tab" aria-controls="upload-information" aria-selected="true"><strong>Complaints &amp; General Queries</strong></a>
                  <a class="nav-item nav-link acq-nav-btn" id="choose-product-tab" data-toggle="pill" href="#choose-product" role="tab" aria-controls="choose-product" aria-selected="false"><strong>Customer Feedback</strong></a>
                </div>
              </nav>
            </div>
          </div>
          <div class="col-lg-12">
            <div class="tab-content" id="v-pills-tabContent">
              <div class="tab-pane tab-pane-quotation fade show active" id="upload-information" role="tabpanel" aria-labelledby="upload-information-tab">
                <div class="container">
                  <div class="d-block b-b-dashed pb-3">
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <h1 class="ib-claim-listing" style="margin-top:0px !important;">Complaint Listings</h1>
                      </div>
                      <div class="col-md-6">
                        <div class="add-complain-fix">
                          <router-link :to="{ name: 'ComplaintCreate' }" class="ib-btn-primary ib-btn-width ib-btn-hover">Add Complaint</router-link>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-none d-md-block">
                      <table class="claim-listing">
                        <tbody>
                        <tr style="cursor: pointer" v-for="complain in complains" :key="complain.ticket_id" @click="viewComplaint(complain.id)">
                          <td class="jbl-responsive-td complaint-td">
                            <div class="complaint-td-first">
                              <img class="img-fluid" :src="require('@/assets/images/complaint-large-2x.png')">
                            </div>
                          </td>
                          <td class="jbl-table-heading jbl-responsive-td">{{ complain.complain_subject }}</td>
                          <td class="jbl-responsive-td">
                            <div class="jbl-flex-td">
                              <div class="jbl-date-td jbl-date-heading">Token Id</div>
                              <div class="jbl-date-td" style="text-transform: capitalize;">{{ complain.ticket_id }}</div>
                            </div>
                          </td>
                          <td class="jbl-responsive-td">
                            <div class="jbl-flex-td">
                              <div class="jbl-date-td jbl-date-heading">Date.</div>
                              <div class="jbl-date-td">{{ formatDate(complain.created_at) }}</div>
                            </div>
                          </td>
                          <td class="jbl-responsive-td"><div class="ib-status " :class="complain.status +'-status'">{{ complain.status }}</div></td>
                          <td class="jbl-responsive-td in-w-60">
                            <router-link :to="{ name: 'ComplaintView', params: { id: complain.id } }" class="nex-Page-Link">
                              <!-- <i class="fa fa-chevron-right"></i> -->
                              <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">
                            </router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="complains.length === 0">No Self Policy Found</h2>
                    </div>
                    <!-- mobile view -->
                    <div class="col-md-12 d-md-none">
                      <div class="d-flex in-sm-listing ib-cursor-pointer" v-for="complain in complains" :key="complain.ticket_id" @click="viewComplaint(complain.id)">
                        <div class="in-sm-firstdiv">
                          <div class="in-listing-img in-sm-height">
                            <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/complaint-large-2x.png')"/>
                            <!-- <div class="position-relative-box">
                            <img alt="icon" class="img-fluid small-icon" :src="self_policy.company_logo_path" />
                            </div> -->
                          </div>
                        </div>
                        <div class="in-sm-flex1">
                          <div class="d-flex in-sm-date">
                            <div>Date:&nbsp;</div>
                            <div>{{ formatDate(complain.created_at) }}</div>
                          </div>
                          <div class="in-sm-title">{{ complain.complain_subject }}</div>
                            <div class="d-flex">
                              <div class="in-sm-property">Token Id</div>
                              <div class="in-sm-value">{{ complain.ticket_id }}</div>
                            </div>
                          </div>
                          <div class="in-sm-status ib-status" :class="complain.status +'-status'">{{ complain.status }}</div>
                      </div>
                      <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center; " v-if="complains.length === 0">No Policy Found</h5>
                    </div>
                    <!-- mobile view -->
                  </div>
                </div>
              </div>
              <div class="tab-pane tab-pane-quotation fade" id="choose-product" role="tabpanel" aria-labelledby="choose-product-tab">

                <div class="container">
                  <div class="d-block b-b-dashed pb-3">
                    <div class="row mb-4">
                      <div class="col-md-6">
                        <h1 class="ib-claim-listing" style="margin-top:0px !important;">Complaint Listings</h1>
                      </div>
                      <div class="col-md-6">
                        <div class="add-complain-fix">
<!--                          <router-link :to="{ name: 'ComplaintCreate' }" class="ib-btn-primary ib-btn-width ib-btn-hover">Add Complaint</router-link>-->
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 d-none d-md-block">
                      <table class="claim-listing">
                        <tbody>
                        <tr @click="visitRoute('Overall')">
                          <td class="jbl-responsive-td complaint-td feedback-td">
                            <div class="complaint-td-first">
                              <img class="img-fluid" :src="require('@/assets/images/overall-feedback-2x.png')">
                            </div>
                          </td>
                          <td class="jbl-table-heading jbl-responsive-td feedback-text">
                            <div>Overall Feedback</div>
                            <div>Please Check Your Complaints</div>
                          </td>
                          <td class="jbl-responsive-td in-w-10">
                            <router-link :to="{ name: 'Overall'}" class="nex-Page-Link">
                              <!-- <i class="fa fa-chevron-right"></i> -->
                            <!--  <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">-->
                              <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                            </router-link>
                          </td>
                        </tr>
                        <tr @click="visitRoute('PoliciesFeedback')">
                          <td class="jbl-responsive-td complaint-td feedback-td">
                            <div class="complaint-td-first">
                              <img class="img-fluid" :src="require('@/assets/images/policy-feedback-2x.png')">
                            </div>
                          </td>
                          <td class="jbl-table-heading jbl-responsive-td feedback-text">
                            <div>Policies</div>
                            <div>Please Give Your Feedback</div>
                          </td>
                          <td class="jbl-responsive-td in-w-10">
                            <router-link :to="{ name: 'PoliciesFeedback' }" class="nex-Page-Link">
                           <!--   <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon">-->
                              <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                              <!-- <i class="fa fa-chevron-right"></i> -->
                            </router-link>
                          </td>
                        </tr>
                        <tr @click="visitRoute('ClaimsFeedback')">
                          <td class="jbl-responsive-td complaint-td feedback-td">
                            <div class="complaint-td-first">
                              <img class="img-fluid" :src="require('@/assets/images/claim-feedback-2x.png')">
                            </div>
                          </td>
                          <td class="jbl-table-heading jbl-responsive-td feedback-text">
                            <div>Claims</div>
                            <div>Please Give Your Feedback</div>
                          </td>
                          <td class="jbl-responsive-td in-w-10">
                            <router-link :to="{ name: 'ClaimsFeedback'}" class="nex-Page-Link">
                              <!-- <i class="fa fa-chevron-right"></i> -->
                              <!-- <img class="img-fluid in-w-10" :src="require('@/assets/images/arrow-down-icon.svg')" alt="icon"> -->
                              <span style="float:right" ><i class="arrow_risk right1 feedback_arrow"></i></span>
                            </router-link>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      <!-- <h2 style="color: rgba(0, 0, 0, 0.3) !important " v-if="complains.length === 0">No Self Policy Found</h2> -->
                    </div>
                    <!-- mobile view -->
                    <div class="col-md-12 d-md-none">
                      <div class="d-flex in-sm-listing ib-cursor-pointer" @click="visitRoute('Overall')">
                        <div class="in-sm-firstdiv">
                          <div class="in-listing-img in-sm-height">
                            <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/overall-feedback-2x.png')"/>
                          </div>
                        </div>
                        <div class="in-sm-flex1">
                          <div class="in-sm-title">Overall Feedback</div>
                            <div class="d-flex">
                              <div class="in-sm-property">Please Give Your Feedback</div>
                            </div>
                          </div>
                      </div>
                      <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center; " v-if="complains.length === 0">No Policy Found</h5>
                    </div>
                    <div class="col-md-12 d-md-none">
                      <div class="d-flex in-sm-listing ib-cursor-pointer" @click="visitRoute('PoliciesFeedback')">
                        <div class="in-sm-firstdiv">
                          <div class="in-listing-img in-sm-height">
                            <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/policy-feedback-2x.png')"/>
                          </div>
                        </div>
                        <div class="in-sm-flex1">
                          <div class="in-sm-title">Policies</div>
                            <div class="d-flex">
                              <div class="in-sm-property">Please Give Your Feedback</div>
                            </div>
                          </div>
                      </div>
                      <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center; " v-if="complains.length === 0">No Policy Found</h5>
                    </div>
                    <div class="col-md-12 d-md-none">
                      <div class="d-flex in-sm-listing ib-cursor-pointer" @click="visitRoute('ClaimsFeedback')">
                        <div class="in-sm-firstdiv">
                          <div class="in-listing-img in-sm-height">
                            <img class="img-fluid" style="width:64px;" :src="require('@/assets/images/claim-feedback-2x.png')"/>
                          </div>
                        </div>
                        <div class="in-sm-flex1">
                          <div class="in-sm-title">Claims</div>
                            <div class="d-flex">
                              <div class="in-sm-property">Please Give Your Feedback</div>
                            </div>
                          </div>
                      </div>
                      <h5 style="color: rgba(0, 0, 0, 0.3) !important; text-align:center; " v-if="complains.length === 0">No Policy Found</h5>
                    </div>
                    <!-- mobile view -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'Complaint',
    components: {
      loading
    },
    data () {
      return {
        showLoader: false,
        complainsList: {},
        complains: {},
        complaints : {},
      };
    },
    created: function () {
      const self = this;
      self.getComplains();
    },
    methods: {
      formatDate(date) {
        return moment(date, "YYYY-MM-DD").format('DD-MMM-YYYY');
      },
      async getComplains() {
        var self = this;
        self.showLoader = true;
        await axios.get('customer/complains').then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.complains = resp.data.data;
            self.complaints = resp.data.data;
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      filterSearch(key) {
        const self = this;
        self.complains = self.complaints.filter(x => x.title.toLowerCase().includes(key.target.value.toLowerCase()));
      },
      viewComplaint(complainId) {
        const self = this;
        self.$router.push({ name: 'ComplaintView', params: { id: complainId } });
      },
      visitRoute(name) {
        const self = this;
        self.$router.push({ name: name });
      }
    }
  };
</script>

<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 9px 0;
    padding: 10px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
  }
  .position-relative .small-icon{
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 14px;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 84px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child {
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 0 0px 1px #d8eaf1;
    }
  }
  .jbl-table-heading {
    font-family: "Avenir Medium";
    font-weight: 500;
    text-align: left !important;
    font-size: 19px;
    color: #5b6770;
    text-transform: capitalize;
  }
  .jbl-table-heading span {
    font-weight: normal !important;
    font-size: 10px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-table-heading small {
    font-weight: normal !important;
    font-size: 11px !important;
    font-weight: 500 !important;
    color: #ef7c94 !important;
  }
  .jbl-date-td {
    font-family: "Avenir Medium";
    font-size: 19px;
    font-weight: 500;
    text-align: left;
    color: #5b6770;
  }
  .jbl-date-heading {
    color: #ef7c94 !important;
    font-family: "Avenir Book";
    font-size: 13px;
    text-align: left;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  .jbl-flex-td {
    display: flex;
    flex-direction: column;
  }
  @media (min-width:668px) and (max-width:992px) {
    .jbl-table-heading {
      font-size: 14px;
    }
    .jbl-date-td {
      font-family: "Futura PT Medium";
      font-size: 12px;
    }
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  /* table.claim-listing tr td:last-child {
    text-align: right !important;
  } */
</style>



// WEBPACK FOOTER //
// src/views/ComplaintFeedback/Index.vue